import { Box, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSubscriptions } from "../../../hooks/billingHooks";
import { apixios } from "../../../lib/axios";
import Button from "../../atoms/button/Button";
import useAuthContext from "../../context/AuthContext";
import Loading from "../others/Loading";


const Plan = () => {
  const router = useRouter();
  const {currentShop, setCurrentShop, currentAuthority} = useAuthContext();
  const {plans, setPlans, planLoading} = useSubscriptions(currentAuthority)
  const [minimums, setMinimums] = useState([])
  const [normals, setNormals] = useState([])
  const [enterprises, setEnterprises] = useState([])
  const [someSubscription, setSomeSubscription] = useState(false)

  useEffect(() => {
    if (!plans?.length) return
    const _minimums = plans.filter((plan) => plan.isActive() && plan.isMinimum())
    const _normals = plans.filter((plan) => plan.isActive() && plan.isNormal())
    const _enterprises = plans.filter((plan) => plan.isActive() && plan.isEnterprise())
    if (_minimums?.length + _normals?.length + _enterprises?.length > 1) {
      setSomeSubscription(true)
    } else {
      setSomeSubscription(false)
    }
    setMinimums(_minimums)
    setNormals(_normals)
    setEnterprises(_enterprises)
  }, [plans])

  const onClickTrial = () => {
    const deleteTarget = [...normals, ...enterprises]
    deleteTarget.forEach((target) => {
      onClickDelete(target.id)
    })
    apixios.post('/api/plans/subscribe-free-trial').then((res) => {
      setCurrentShop({
        ...currentShop,
        alreadyTrial: true
      })
      router.push(res.data.confirmationUrl)
    })
  }
  const onClickMinimum = () => {
    const deleteTarget = [...normals, ...enterprises]
    deleteTarget.forEach((target) => {
      onClickDelete(target.id)
    })
    apixios.post('/api/plans/subscribe-minimum').then((res) => {
      router.push(res.data.confirmationUrl)
    })
  }
  const onClickNormal = () => {
    const deleteTarget = [...minimums, ...enterprises]
    deleteTarget.forEach((target) => {
      onClickDelete(target.id)
    })
    apixios.post('/api/plans/subscribe-normal').then((res) => {
      router.push(res.data.confirmationUrl)
    })
  }
  const onClickEnterprise = () => {
    const deleteTarget = [...minimums, ...normals]
    deleteTarget.forEach((target) => {
      onClickDelete(target.id)
    })
    apixios.post('/api/plans/subscribe-enterprise').then((res) => {
      router.push(res.data.confirmationUrl)
    })
  }

  const onClickDelete = (id) => {
    apixios.post('/api/plans/delete-subscription', {
      id: id
    }).then((res) => {
      setPlans(plans.filter((plan) => plan.id != id))
    }).catch((error) => {
      console.log(error);
      setPlans(plans.filter((plan) => plan.id != id))
    })
  }

  return (
    <div className="container mx-auto p-10">
      <h2 className="text-5xl mb-5 mt-20">プラン</h2>
      <p className="text-2xl ml-1 mb-14 leading-9">
        {currentShop?.domain?.replace('.myshopify.com','')}様<br />
        ご利用いただき誠にありがとうございます。人数に合わせてプランをお選びください。
      </p>
      { someSubscription && (<div className="bg-rose-300 rounded"></div>)}
      <div className="flex justify-center">
        { currentShop?.alreadyTrial && 
          <div className="border rounded p-5 bg-white mr-5 last:mr-0 w-3/12 flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-bold mb-2">ミニマムプラン</h3>
            </div>
            <p className="mb-5 text-7xl text-gray-600">49$<span className="text-3xl ml-3 font-bold">/ month</span></p>
            <p className="mb-10 text-xl">0-5人までのプランです。</p>
            <div>
              { !minimums && planLoading && <Loading /> }
              { minimums.length > 0 ? (<div>
                <p className="mb-3 text-2xl text-white bg-rose-500 rounded p-2 font-bold">ご利用中</p>
                <Button onClick={() => onClickDelete(minimums[0].id)}>解除</Button>
              </div>) : (<div>
                <Button onClick={onClickMinimum}>登録</Button>
              </div>)}
            </div>
          </div>
        }
        { !currentShop?.alreadyTrial &&
          <div className="border rounded p-5 bg-white mr-5 last:mr-0 w-3/12 flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-bold mb-2">ミニマムプラン</h3>
              <p className="mb-5 text-red-500 text-xl font-bold">（7日間のフリートライアル付き）</p>
            </div>
            <p className="mb-5 text-7xl text-gray-600">49$<span className="text-3xl ml-3 font-bold">/ month</span></p>
            <p className="mb-10 text-xl">0-5人までのプランです。<br />フリートライアル後は自動で課金が開始されます。</p>
            <div>
              { !minimums && planLoading && <Loading /> }
              { minimums.length > 0 ? (<div>
                <p className="mb-3 text-2xl text-white bg-rose-500 rounded p-2 font-bold">ご利用中</p>
                <Button onClick={() => onClickDelete(minimums[0].id)}>解除</Button>
              </div>) : (<div>
                <Button onClick={onClickTrial}>登録</Button>
              </div>)}
            </div>
          </div>
        }
        <div className="border rounded p-5 bg-white mr-5 last:mr-0 w-3/12 flex flex-col justify-between">
          <div>
            <h3 className="text-2xl font-bold mb-14">ノーマルプラン</h3>
            <p className="mb-10 text-7xl text-gray-600">98$<span className="text-3xl ml-3 font-bold">/ month</span></p>
            <p className="mb-10 text-xl">6-10人までのプランです。</p>
          </div>
          <div>
            { !normals && planLoading && <Loading /> }
            { normals.length > 0 ? (<div>
              <p className="mb-3 text-2xl text-white bg-rose-500 rounded p-2 font-bold">ご利用中</p>
              <Button onClick={() => onClickDelete(normals[0].id)}>解除</Button>
            </div>) : (<div>
              <Button onClick={onClickNormal} className={'w-full'}><span className="block py-4 text-3xl">登録</span></Button>
            </div>)}
          </div>
        </div>
        <div className="border rounded p-5 bg-white mr-5 last:mr-0 w-3/12 flex flex-col justify-between">
          <div>
            <h3 className="text-2xl font-bold mb-14">エンタープライズプラン</h3>
            <p className="mb-10 text-7xl text-gray-600">198$<span className="text-3xl ml-3 font-bold">/ month</span></p>
            <p className="mb-10 text-xl">11人以上のプランです。</p>
          </div>
          <div>
            { !enterprises && planLoading && <Loading /> }
            { enterprises.length > 0 ? (<div>
              <p className="mb-3 text-2xl text-white bg-rose-500 rounded p-2 font-bold">ご利用中</p>
              <Button onClick={() => onClickDelete(enterprises[0].id)}>解除</Button>
            </div>) : (<div>
              <Button onClick={onClickEnterprise} className={'w-full'}><span className="block py-4 text-3xl">登録</span></Button>
            </div>)}
          </div>
        </div>
      </div>
      <Text fontSize={'xs'} mt={5} rounded={'sm'} px={[4,5,6,7]}>
        登録もしくは解除ボタンを押して決済の確定をしていただくことで、<br />
        お客様は当サイトの
        <Box as='span' textColor={'blue.300'}>
          <Link href='/policy'>プライバシー規約</Link>
        </Box>
        に同意の上、
        登録もしくは解除されたことになります。
      </Text>
    </div>
  );
}

export default Plan;